var _g, _g2, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGarbageWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#FFFFFF",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 492.308 492.308",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 151.852,
    y: 163.175,
    transform: "matrix(0.9971 -0.0764 0.0764 0.9971 -21.7697 13.2064)",
    width: 19.692,
    height: 255.833
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 236.308,
    y: 163.545,
    width: 19.692,
    height: 255.084
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 202.697,
    y: 281.247,
    transform: "matrix(0.0762 -0.9971 0.9971 0.0762 15.1818 598.5728)",
    width: 255.831,
    height: 19.692
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M448.627,70.115h-51.173V27.577C397.454,12.375,385.089,0,369.887,0H122.416c-15.202,0-27.567,12.375-27.567,27.577 v42.538H43.675H14.752v19.692h31.363L91.06,452.51c2.813,22.692,22.178,39.798,45.043,39.798H356.2 c22.865,0,42.231-17.106,45.043-39.798l44.945-362.702h31.368V70.115H448.627z M114.541,27.577c0-4.346,3.534-7.885,7.875-7.885 h247.471c4.341,0,7.875,3.538,7.875,7.885v42.538H114.541V27.577z M381.704,450.087c-1.596,12.846-12.558,22.529-25.505,22.529 H136.103c-12.947,0-23.909-9.683-25.505-22.529L65.954,89.808h28.894h302.606h28.894L381.704,450.087z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGarbageWhite);
export default __webpack_public_path__ + "static/media/garbageWhite.ca2df0035ed548181801bfa6b5764173.svg";
export { ForwardRef as ReactComponent };